import { useMutation } from '@tanstack/react-query';
import { getCredits } from '../queries';

export function useGetUserCredit() {
  const { mutate, data, isPending } = useMutation({
    mutationKey: ['getusercredit'], 
    mutationFn: () => getCredits(),
    retry: false
  });

  return { mutate, data, isPending };
}
